import React from 'react';

export const ClickUpSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="32" height="32" rx="8" fill="white" />
			<rect
				x="0.508324"
				y="0.508324"
				width="30.9834"
				height="30.9834"
				rx="7.49168"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.01665"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.30859 20.8905L10.5124 18.2109C12.2253 20.6157 14.0334 21.7494 16.0318 21.7494C18.0302 21.7494 19.8065 20.65 21.4243 18.2453L24.6915 20.8562C22.3442 24.2915 19.4259 26.1123 16.0318 26.1123C12.6694 26.1123 9.71936 24.2915 7.30859 20.8905Z"
				fill="#6686FB"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 10.1366L10.0515 15.0505L7.30859 11.9753L16.0331 4.77881L24.6915 11.9753L21.9155 15.0188L16 10.1366Z"
				fill="#FF6479"
			/>
		</svg>
	);
};
